export default __webpack_public_path__ + "static/media/agrupments.016a6616.svg";